import { Menu } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { openRadarTemplateModalForCreateAtom, radarTemplateIdAtom } from '@/atoms/radar';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { GenericRenameModal } from '@/components/modal/GenericRenameModal/GenericRenameModal';
import { ShareUserConfigModal } from '@/components/modal/ShareUserConfigModal/ShareUserConfigModal';
import { RADAR_TEMPLATE } from '@/consts/searchKeys';
import { MoreOptionsMenu } from '../../menu/MoreOptionsMenu/MoreOptionsMenu';
import { CreateRadarTemplateModal } from '../../modal/CreateRadarTemplateModal/CreateRadarTemplateModal';
import { GenericDeleteModal } from '../../modal/GenericDeleteModal/GenericDeleteModal';
import { RadarTemplateDeleteMenuOption } from './RadarTemplateDeleteMenuOption';
import { RadarTemplateDuplicateMenuOption } from './RadarTemplateDuplicateMenuOption';
import { RadarTemplateEditMenuOption } from './RadarTemplateEditMenuOption';
import { RadarTemplateRenameMenuOption } from './RadarTemplateRenameMenuOption';
import { RadarTemplateShareMenuOption } from './RadarTemplateShareMenuOption';

export const RadarTemplateMenu = () => {
  const { t } = useTranslation('radar');
  const isPlayerSection = !!useMatch('/:locale/player/*');
  const entity = isPlayerSection ? 'player' : 'team';
  const openRadarTemplateModalForCreate = useSetAtom(openRadarTemplateModalForCreateAtom);
  const setRadarTemplateId = useSetAtom(radarTemplateIdAtom);

  return (
    <>
      <MoreOptionsMenu testId="radar-edit-template-menu">
        <Menu testId="radar-edit-template-menu-options">
          <RadarTemplateEditMenuOption />
          <RadarTemplateRenameMenuOption />
          <RadarTemplateDuplicateMenuOption />
          <RadarTemplateShareMenuOption />
          <RadarTemplateDeleteMenuOption />
          <hr className="border-t border-canvas-primary-main opacity-80" />
          <MenuItemWithIcon
            onClick={openRadarTemplateModalForCreate}
            text={t(`templateSelector.createNewRadarTemplate.${entity}`)}
          />
        </Menu>
      </MoreOptionsMenu>

      <CreateRadarTemplateModal />
      <GenericDeleteModal configParamKey={RADAR_TEMPLATE} onSuccess={() => setRadarTemplateId('')} />
      <GenericRenameModal />
      <ShareUserConfigModal />
    </>
  );
};
